import React from "react"

import { css } from "@emotion/react"

import { NIRVANA_COLORS } from "../config/theme.config.ts"
import { UtilHelper } from "../helpers/util.helper.ts"

import bottomShadowImage from "@front-shared/assets/images/elements/avatar/bottom-shadow.svg"

export const AvatarElement: React.FunctionComponent<
    IAvatarElementProps
> = props => {
    return (
        <div
            className={`
                relative
                ${props.className}
            `}
        >
            <div
                css={[
                    styles.innerWrapper,
                    !props.bgClassName
                        ? styles.innerWrapperBackground
                        : undefined,
                ]}
                className={`
                    ${props.fontClassName}
                    ${props.bgClassName}
                `}
                style={{
                    width: `${props.width}px`,
                    height: `${props.width}px`,
                }}
            >
                {UtilHelper.buildUserAbbreviation(props.user)}
            </div>

            {props.withShadow && (
                <div
                    css={styles.shadowWrapper}
                    style={{ bottom: `${-((props.shadowHeight || 10) + 5)}px` }}
                >
                    <img
                        src={bottomShadowImage}
                        alt={props.user?.name || ""}
                        title={props.user?.name || ""}
                        style={{
                            width: `${props.width}px`,
                            height: props.shadowHeight
                                ? `${props.shadowHeight}px`
                                : undefined,
                        }}
                    />
                </div>
            )}
        </div>
    )
}

const styles = {
    innerWrapper: css({
        borderRadius: 777,
        color: NIRVANA_COLORS.brand.white,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }),
    innerWrapperBackground: css({
        backgroundColor: NIRVANA_COLORS.brand.primary,
    }),
    shadowWrapper: css({
        position: "absolute",
        left: 0,
    }),
}

interface IAvatarElementProps {
    className?: string
    user?: {
        name?: string | null
        firstName?: string | null
        lastName?: string | null
    } | null
    width: number
    withShadow?: boolean
    shadowHeight?: number
    fontClassName?: string
    bgClassName?: string
}
